import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { DatePicker } from "gatsby-theme-gba"

const DatePickerEditable = ({ blok, visible }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <DatePicker
      name={blok.name}
      label={blok.label}
      value={blok.value}
      placeholder={blok.placeholder}
      required={blok.required}
      flex={blok.flex}
      currentLanguage={blok.currentLanguage}
      visible={visible}
      showTimeSelect={blok.showTimeSelect}
      excludeDates={blok.excludeDays}
      businessHours={[
        {
          open: blok.isOpenSunday,
          minHour: blok.minHourSunday,
          minMinute: blok.minMinuteSunday,
          maxHour: blok.maxHourSunday,
          maxMinute: blok.maxMinuteSunday,
        },
        {
          open: blok.isOpenMonday,
          minHour: blok.minHourMonday,
          minMinute: blok.minMinuteMonday,
          maxHour: blok.maxHourMonday,
          maxMinute: blok.maxMinuteMonday,
        },
        {
          open: blok.isOpenThuesday,
          minHour: blok.minHourThuesday,
          minMinute: blok.minMinuteThuesday,
          maxHour: blok.maxHourThuesday,
          maxMinute: blok.maxMinuteThuesday,
        },
        {
          open: blok.isOpenWednesday,
          minHour: blok.minHourWednesday,
          minMinute: blok.minMinuteWednesday,
          maxHour: blok.maxHourWednesday,
          maxMinute: blok.maxMinuteWednesday,
        },
        {
          open: blok.isOpenThursday,
          minHour: blok.minHourThursday,
          minMinute: blok.minMinuteThursday,
          maxHour: blok.maxHourThursday,
          maxMinute: blok.maxMinuteThursday,
        },
        {
          open: blok.isOpenFriday,
          minHour: blok.minHourFriday,
          minMinute: blok.minMinuteFriday,
          maxHour: blok.maxHourFriday,
          maxMinute: blok.maxMinuteFriday,
        },
        {
          open: blok.isOpenSaturday,
          minHour: blok.minHourSaturday,
          minMinute: blok.minMinuteSaturday,
          maxHour: blok.maxHourSaturday,
          maxMinute: blok.maxMinuteSaturday,
        },
      ]}
    />
  </div>
)

export default DatePickerEditable
